module.exports = __webpack_public_path__ + "media/images/knock_out-eb686cc86ba266183a9d0e4f1f20db7c.png";